import React from 'react';
import { Chip } from '@mui/material';
import {
  Login as SignedInIcon,
  Logout as SignedOutIcon,
  Info as UnknownIcon,
} from '@mui/icons-material';
import { appColors } from '../../Config/Theme';
import type { LobbyTrackChipTone } from '../../Utils/lobbyTrackDisplay';

interface LobbyTrackVisitChipProps {
  label: string;
  tone: LobbyTrackChipTone;
  size?: 'small' | 'medium';
}

const TONE_STYLES: Record<LobbyTrackChipTone, { bg: string; fg: string }> = {
  info: { bg: '#E3F2FD', fg: '#1565C0' },
  attention: { bg: '#FFF3E0', fg: '#E65100' },
  success: { bg: appColors.status.successBg, fg: appColors.status.success },
  neutral: { bg: '#ECEFF1', fg: '#546E7A' },
};

const TONE_ICON: Record<LobbyTrackChipTone, React.ReactElement> = {
  info: <SignedInIcon sx={{ fontSize: 12 }} />,
  attention: <SignedInIcon sx={{ fontSize: 12 }} />,
  success: <SignedOutIcon sx={{ fontSize: 12 }} />,
  neutral: <UnknownIcon sx={{ fontSize: 12 }} />,
};

const LobbyTrackVisitChip: React.FC<LobbyTrackVisitChipProps> = ({
  label,
  tone,
  size = 'small',
}) => {
  const style = TONE_STYLES[tone];
  return (
    <Chip
      label={label}
      size={size}
      icon={TONE_ICON[tone]}
      sx={{
        height: 18,
        fontSize: '0.65rem',
        fontWeight: 600,
        bgcolor: style.bg,
        color: style.fg,
        '& .MuiChip-icon': { color: style.fg },
      }}
    />
  );
};

export default React.memo(LobbyTrackVisitChip);
